"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />
      }}
      style={
        {
          "--normal-bg": "#e6f0f8",
          "--normal-text": "#1f2937",
          "--normal-border": "var(--border)",
          "--border-radius": "8px",
          "--success-bg": "#e6f0f8",
          "--success-text": "#1f2937",
          "--error-bg": "#e6f0f8",
          "--error-text": "#1f2937",
          "--warning-bg": "#e6f0f8",
          "--warning-text": "#1f2937",
          "--info-bg": "#e6f0f8",
          "--info-text": "#1f2937"
        } as React.CSSProperties
      }
      theme={theme as ToasterProps["theme"]}
      {...props}
    />
  )
}

export { Toaster }
